import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createRefiAutoOriginationCheckThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(ApplicationProcessActionTypes.RefiAutoOriginationCheck, async () => {
    const response = await api.refiAutoOriginationCheck();
    return response;
  });
